import { useContext } from "react";

import { WAFEdgeContext } from "../../../contexts/super/nodes/WAFEdgeContext";

// Slimmed 2026-05-30 (Step 7a): per-engine hook dispatcher (getWAFHook)
// removed along with the legacy WAF/LLM/AU/ES/BM/AD engine list pages.
// The new super-admin engine pages live at /super/engines/{pingora,bm,ad}
// and use the EngineClusterPage/EngineDrillDownPage components instead.
//
// Default export is still used by:
//   - pages/super/waf/config.js (edge certificate management)
//   - components/pages/super/region/M_Region.js (allWafEdges list)

const useWAFEdge = () => {
  const context = useContext(WAFEdgeContext);
  return context;
};

export default useWAFEdge;
